__turbopack_context__.v({
  "backdrop": "Modal-module-scss-module__hcjTra__backdrop",
  "content": "Modal-module-scss-module__hcjTra__content",
  "fade-in": "Modal-module-scss-module__hcjTra__fade-in",
  "fade-out": "Modal-module-scss-module__hcjTra__fade-out",
  "fullscreen": "Modal-module-scss-module__hcjTra__fullscreen",
  "innerContent": "Modal-module-scss-module__hcjTra__innerContent",
  "scale-fade-in": "Modal-module-scss-module__hcjTra__scale-fade-in",
  "scale-fade-out": "Modal-module-scss-module__hcjTra__scale-fade-out",
});
